import React, { useContext, useEffect } from "react";
import CustomCard from "../../styleComp/CustomCard";
import ImageCard from "./ImageCard";
import InfoCard from "./InfoCard";
import NavigationCard from "../AppBar/NavigationCard";
import { Box, Card } from "@mui/material";
import { RolesContext } from "../../context/User";
import { useErrValidate } from "../../utilitis/AuthorizationPage";
import Grid from "@mui/material/Unstable_Grid2";
import ProfileCard from "./Profile";
import TwoInfoCard from "./twoInforCard";
import NavigationMenuCard from "./NavigationMenuCard";
import PopupWithSelect from "../Popup";
import NursinghomeHomePage from "../Nursinghome/NursinghomeHomePage";
import HospitalHomePage from "../Hospital/HospitalHomePage";

const HomePagecard = () => {
  const [stateroles, dispatchroles] = useContext(RolesContext);
  const { validationPage } = useErrValidate();
  useEffect(() => {
    validationPage("portal");
  }, [stateroles.userId]);

  const hasNursinghomeRole =
    stateroles.roles?.includes("nursinghome") ||
    (stateroles.roles?.includes("admin") && stateroles.priorityCode === "B");

  const hasHospitalRole =
    stateroles.roles?.includes("hospital") ||
    (stateroles.roles?.includes("admin") && stateroles.priorityCode === "D");

  return (
    <>
      {stateroles.userId ? (
        <>
          {hasHospitalRole ? (
            <HospitalHomePage />
          ) : hasNursinghomeRole ? (
            <NursinghomeHomePage />
          ) : (
            <>
          <Box sx={{ display: { xs: "none", md: "block", xl: "block" } }}>
            <Grid
              container
              rowSpacing={4}
              columnSpacing={{ xs: 3, sm: 3, md: 3 }}
            >
              <Grid xs={8}>
                <NavigationMenuCard />
              </Grid>
              <Grid xs={4}>
                <ImageCard />
              </Grid>
            </Grid>
            <Grid
              container
              rowSpacing={4}
              columnSpacing={{ xs: 3, sm: 3, md: 3 }}
            >
              {(stateroles.roles.includes("linkopeninvoice") || stateroles.roles.includes("admin")) && stateroles.priorityCode === "A" && (
                <Grid xs={3}>
                  <TwoInfoCard />
                </Grid>
              )}
              <Grid xs={(stateroles.roles.includes("linkopeninvoice") || stateroles.roles.includes("admin")) && stateroles.priorityCode === "A" ? 6 : 9}>
                <InfoCard />
              </Grid>
              <Grid xs={3}>
                <ProfileCard />
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ display: { xs: "block", md: "none", xl: "none" } }}>
            {/* <NavigationMenuCard /> */}
            <div style={{ marginTop: "1rem" }}></div>
            {(stateroles.roles.includes("linkopeninvoice") || stateroles.roles.includes("admin")) && stateroles.priorityCode === "A" && (
              <>
                <TwoInfoCard colorCard={"rgb(245,245,245)"} mobil={true} />
                <div style={{ marginTop: "1rem" }}></div>
              </>
            )}
            <InfoCard colorCard={"rgb(245,245,245)"} mobil={true} />
            <div style={{ marginTop: "1rem" }}></div>
            <ProfileCard colorCard={"rgb(245,245,245)"} mobil={true} />
            <div style={{ marginBottom: "3rem" }}></div>
          </Box>
          </>
          )}
        </>
      ) : (
        <PopupWithSelect />
      )}
    </>
  );
};

export default HomePagecard;
